module.exports = __webpack_public_path__ + "shared/static_img/whatsapp.d7ca001c.png";